import { extensionToMimeTypeMap } from '../constants';
import { getExtensionFromFileName } from './common';
import { createImg } from './createImg';

const getRadianAngle = (degreeValue) => {
  return (degreeValue * Math.PI) / 180;
};

const rotateSize = (width, height, rotation) => {
  const rotRad = getRadianAngle(rotation);

  return {
    width:
      Math.abs(Math.cos(rotRad) * width) + Math.abs(Math.sin(rotRad) * height),
    height:
      Math.abs(Math.sin(rotRad) * width) + Math.abs(Math.cos(rotRad) * height),
  };
};

export const transformBase64ToFile = (base64, fileName) => {
  if (!base64) return null;

  let data = base64;

  if (base64.includes(',')) {
    const parts = base64.split(',');
    data = parts[1];
  }

  const binaryStr = atob(data);
  const byteNumbers = Array.from(binaryStr, (char) => char.charCodeAt(0));
  const byteArray = new Uint8Array(byteNumbers);

  return new File([byteArray], fileName);
};

export const getCroppedFile = async ({
  src,
  fileName,
  pxlCrop,
  rotation = 0,
  flip = { horizontal: false, vertical: false },
}) => {
  const image = await createImg(src);
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  if (!ctx) {
    return null;
  }

  const rotRad = getRadianAngle(rotation);

  const { width: bBoxWidth, height: bBoxHeight } = rotateSize(
    image.width,
    image.height,
    rotation
  );

  // set canvas size to match the bounding box
  canvas.width = bBoxWidth;
  canvas.height = bBoxHeight;

  // translate canvas context to a central location to allow rotating and flipping around the center
  ctx.translate(bBoxWidth / 2, bBoxHeight / 2);
  ctx.rotate(rotRad);
  ctx.scale(flip.horizontal ? -1 : 1, flip.vertical ? -1 : 1);
  ctx.translate(-image.width / 2, -image.height / 2);

  // draw rotated image
  ctx.drawImage(image, 0, 0);

  const croppedCanvas = document.createElement('canvas');

  const croppedCtx = croppedCanvas.getContext('2d');

  if (!croppedCtx) {
    return null;
  }

  // Set the size of the cropped canvas
  croppedCanvas.width = pxlCrop.width;
  croppedCanvas.height = pxlCrop.height;

  // Draw the cropped image onto the new canvas
  croppedCtx.drawImage(
    canvas,
    pxlCrop.x,
    pxlCrop.y,
    pxlCrop.width,
    pxlCrop.height,
    0,
    0,
    pxlCrop.width,
    pxlCrop.height
  );

  const extension = getExtensionFromFileName(fileName) || 'jpg';
  const mimeType =
    extensionToMimeTypeMap[extension] || extensionToMimeTypeMap.jpg;

  const dataURL = croppedCanvas.toDataURL(mimeType);
  return transformBase64ToFile(dataURL, `cropped.${extension}`);
};
